/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FieldPermission {
    ReadOnly = 'ReadOnly',
    FullControl = 'FullControl'
}

export function FieldPermissionFromJSON(json: any): FieldPermission {
    return FieldPermissionFromJSONTyped(json, false);
}

export function FieldPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldPermission {
    return json as FieldPermission;
}

export function FieldPermissionToJSON(value?: FieldPermission | null): any {
    return value as any;
}

